import { useState } from "react";
import usePipedrivePersonSearch from "../../hooks/usePipedrivePersonSearch";
import IInputProps from "./IInputProps";
import InputContainer from "./InputContainer";
import InputWithSearch from "./InputWithSearchFormikString";

export default <T,>({ name, label, formik, showNewLabel }: IPipedrivePersonInputProps<T>) => {
    const [query, setQuery] = useState(formik.values[name] as string || "");
    const searchResult = usePipedrivePersonSearch(query);

    return (
        <InputContainer name={name} label={label} formik={formik}>
            <InputWithSearch
                name={name}
                formik={formik}
                debouncedOnChange={setQuery}
                searchResult={{
                    query: query,
                    items: searchResult,
                }}
                showNewLabel={showNewLabel ?? true}
            />
        </InputContainer>
    );
}

interface IPipedrivePersonInputProps<T> extends IInputProps<T, string> {
    showNewLabel?: boolean;
}